import { Resource, ResourceType } from 'json-api-hooks';
import React, { useMemo } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import normalizedLower from '../../../lib/i18n';
import { FormFieldOption } from '../ResourceForm';

import useFieldOptions from './useFieldOptions';

const DEBOUNCE_TIMEOUT = 500;

export interface AsyncFieldOptions {
  loading: boolean;
  options: FormFieldOption[];
}

const useAsyncFieldOptions = (
  resource: Resource | undefined,
  resourceType: ResourceType,
  inputValue: string,
): AsyncFieldOptions => {
  const [searchInputValue, setSearchInputValue] = React.useState(inputValue);
  const resourceOpts = useMemo(() => ({ query: searchInputValue }), [searchInputValue]);
  const { loading, options } = useFieldOptions([], resource, resourceType, resourceOpts);
  const [debouncedSearchInputChange] = useDebouncedCallback(
    (newValue) => {
      setSearchInputValue(normalizedLower(newValue));
    },
    DEBOUNCE_TIMEOUT,
    { leading: true },
  );
  React.useEffect(() => {
    if (inputValue !== searchInputValue) {
      debouncedSearchInputChange(inputValue);
    }
  }, [inputValue]);

  return {
    loading,
    options,
  };
};

export default useAsyncFieldOptions;
